import React from 'react';

import { Button } from '../common/Button';
import { Modal, ModalButtons } from '../common/Modal';
import { type CommonModalProps } from '../Modals';

type ConfirmGenericProps = {
  modalProps: Partial<CommonModalProps>;
  text: string;
  title?: string;
  hideCancelButton?: boolean;
  cancelBtnText?: string;
  confirmBtnText?: string;
  onConfirm: () => void;
  onCancel?: () => void;
};

export function ConfirmGeneric({
  title,
  modalProps,
  text,
  hideCancelButton,
  cancelBtnText,
  confirmBtnText,
  onConfirm,
  onCancel,
}: ConfirmGenericProps) {
  return (
    // We need zIndex 5001 so that is above the Adoption tour.
    <Modal
      title={title || 'Confirmation'}
      {...modalProps}
      style={{ flex: 0 }}
      overlayStyle={{ zIndex: 50010 }}
      onClose={() => {
        onCancel?.();
        modalProps.onClose();
      }}
    >
      <div dangerouslySetInnerHTML={{ __html: text }} />

      <ModalButtons style={{ marginTop: 10, gap: 10 }}>
        {!hideCancelButton && (
          <Button
            type="bare"
            onClick={() => {
              onCancel?.();
              modalProps.onClose();
            }}
          >
            {cancelBtnText || 'Cancel'}
          </Button>
        )}
        <Button
          type="primary"
          onClick={() => {
            // We first close and then do onConfirm so that if onConfirm
            // opens another modal we keep it open (such as when clicking sync
            // when logged-out and clicking on sign-in)
            modalProps.onClose();
            onConfirm();
          }}
        >
          {confirmBtnText || 'Confirm'}
        </Button>
      </ModalButtons>
    </Modal>
  );
}
